import { DocumentNode, gql } from '@apollo/client';
import { Stack, Text } from '@chakra-ui/react';
import * as React from 'react';

import { Card } from '@/imports/ui/chakra/components/Card';
import { EventPromotionBox } from '@/imports/ui/components/EventPromotionBox';

import { PromotionCard_SimpleEventFragment } from './graphql-types/PromotionCard_SimpleEventFragment';

export const PromotionCard: React.FC<{
  simpleEvent: PromotionCard_SimpleEventFragment;
}> & { simpleEventFragment: DocumentNode } = (props) => {
  const keySponsor = props.simpleEvent.simpleEventSponsors?.keySponsor ?? null;
  const ad = keySponsor?.sponsorship?.ad;

  if (!keySponsor?.sponsorship || !ad) {
    return null;
  }

  return (
    <Stack>
      <Card px="4" py="6">
        <Stack spacing="4">
          <Text textStyle="compactStrong" color="gray.600">
            FEATURED SPONSOR
          </Text>
          <EventPromotionBox
            title={ad.title || ''}
            body={ad.body || ''}
            registerInterestTitle={ad.registerInterestTitle || ''}
            callToAction={ad.callToAction || ''}
            url={ad.url || ''}
            organizationName={keySponsor.name}
            organizationId={keySponsor._id}
            image={ad.adImage?.imageProxy || undefined}
            origin={{ hostedEventId: props.simpleEvent._id }}
            analytics={{
              view: 'eventSimpleEvent',
              tier: keySponsor.sponsorship.currentTier.analyticsTierType,
            }}
            w="60"
          />
        </Stack>
      </Card>
    </Stack>
  );
};

PromotionCard.simpleEventFragment = gql`
  fragment PromotionCard_SimpleEventFragment on SimpleEventV2 {
    _id
    simpleEventSponsors {
      keySponsor {
        ... on Organization {
          _id
          name
          sponsorship {
            currentTier {
              analyticsTierType
            }
            ad(input: { filters: { includeUnpublished: false } }) {
              _id
              title
              body
              registerInterestTitle
              callToAction
              url
              adImage {
                _id
                imageProxy(input: { w: 560 })
              }
            }
          }
        }
      }
    }
  }
`;
